"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEnrollmentsList = exports.getEnrollmentsList = exports.useClassesList = exports.getClassesList = exports.deleteKlassMember = exports.modifyKlassMember = exports.modifyKlassItem = exports.deleteKlassItem = exports.postKlassMenu = exports.postKlassItem = void 0;
const account_1 = require("../../features/base/account");
const functions_1 = require("../functions");
const getToken = () => (0, account_1.getAccessToken)(APP.store.getState);
// (클래스) 클래스 리스트생성
const postKlassItem = async (data) => {
    const url = `/api/mimac/v1/admin/class`; // API 엔드포인트 생성
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
            'X-Tenant-ID': data.tenant_id,
        },
        body: JSON.stringify(data), // classData 객체를 JSON 문자열로 변환하여 전송
    };
    return (0, functions_1.fetchData)(url, options);
};
exports.postKlassItem = postKlassItem;
// (클래스) 클래스 리스트생성
const postKlassMenu = async (data) => {
    const url = `/api/mimac/v1/admin/class/${data.class_id}/hide-menu`; // API 엔드포인트 생성
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(data.props), // classData 객체를 JSON 문자열로 변환하여 전송
    };
    return (0, functions_1.fetchData)(url, options);
};
exports.postKlassMenu = postKlassMenu;
// (클래스) 클래스 리스트 삭제
const deleteKlassItem = async (class_id) => {
    const url = `/api/mimac/v1/admin/class/${class_id}/delete`; // API 엔드포인트 생성
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
    };
    return (0, functions_1.fetchData)(url, options);
};
exports.deleteKlassItem = deleteKlassItem;
// (클래스) 클래스 리스트 수정
const modifyKlassItem = async (data) => {
    const url = `/api/mimac/v1/admin/class/${data.class_id}/update`; // API 엔드포인트 생성
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(data.props), // classData 객체를 JSON 문자열로 변환하여 전송
    };
    return (0, functions_1.fetchData)(url, options);
};
exports.modifyKlassItem = modifyKlassItem;
// (클래스) 클래스 리스트 수정
const modifyKlassMember = async (data) => {
    const url = `/api/mimac/v1/admin/class/${data.class_id}/enroll`; // API 엔드포인트 생성
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(data.props), // classData 객체를 JSON 문자열로 변환하여 전송
    };
    return (0, functions_1.fetchData)(url, options);
};
exports.modifyKlassMember = modifyKlassMember;
// (클래스) 클래스 리스트 수정
const deleteKlassMember = async (data) => {
    const url = `/api/mimac/v1/admin/class/${data.class_id}/leave`; // API 엔드포인트 생성
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(data.props), // classData 객체를 JSON 문자열로 변환하여 전송
    };
    return (0, functions_1.fetchData)(url, options);
};
exports.deleteKlassMember = deleteKlassMember;
// (클래스) 클래스 리스트 조회
const getClassesList = async (props) => {
    const queryString = (0, functions_1.objectToQueryString)(props); // props를 쿼리 문자열로 변환
    const url = `/api/mimac/v1/classes?${queryString}`; // API 엔드포인트 생성
    return (0, functions_1.fetchData)(url);
};
exports.getClassesList = getClassesList;
// (클래스) 클래스 리스트 가져오기
const useClassesList = (data) => {
    return (0, functions_1.useCustomQuery)([data], () => (0, exports.getClassesList)(data));
};
exports.useClassesList = useClassesList;
// (클래스) 이전에 속해있었던 클래스 리스트까지 모두 조회
const getEnrollmentsList = async (props) => {
    const queryString = (0, functions_1.objectToQueryString)(props); // props를 쿼리 문자열로 변환
    const url = `/api/mimac/v1/enrollments?${queryString}`; // API 엔드포인트 생성
    return (0, functions_1.fetchData)(url);
};
exports.getEnrollmentsList = getEnrollmentsList;
// (클래스) 이전에 속해있었던 클래스 리스트까지 모두 조회
const useEnrollmentsList = (data) => {
    return (0, functions_1.useCustomQuery)([data], () => (0, exports.getEnrollmentsList)(data));
};
exports.useEnrollmentsList = useEnrollmentsList;
